import React from "react";

import {
  PlannerEnrollmentDataType,
  ShoppingCartEnrollmentDataType,
  TutorMatchEnrollmentDataType,
} from "./types";

//create a context that will have a generic type that can be used everywhere

type GenericDataProviderContextType<T> =
  | React.Dispatch<React.SetStateAction<T>>
  | undefined;
function createGenericContext<T>(): React.Context<
  GenericDataProviderContextType<T>
> {
  return React.createContext<GenericDataProviderContextType<T>>(undefined);
}

function useGenericContext<T>(
  context: React.Context<GenericDataProviderContextType<T>>
): GenericDataProviderContextType<T> {
  return React.useContext(context);
}

const ShoppingCartEnrollmentDataContext =
  createGenericContext<ShoppingCartEnrollmentDataType>();

const TutorMatchEnrollmentDataContext = React.createContext<{
  tutorMatchEnrollmentData?: TutorMatchEnrollmentDataType;
  setTutorMatchEnrollmentData?: React.Dispatch<
    React.SetStateAction<TutorMatchEnrollmentDataType>
  >;
}>({
  tutorMatchEnrollmentData: undefined,
  setTutorMatchEnrollmentData: undefined,
});

const useShoppingCartEnrollmentDataContext = () =>
  useGenericContext(ShoppingCartEnrollmentDataContext);
const useTutorMatchContext = () =>
  React.useContext(TutorMatchEnrollmentDataContext);

export {
  useShoppingCartEnrollmentDataContext,
  useTutorMatchContext,
  ShoppingCartEnrollmentDataContext,
  TutorMatchEnrollmentDataContext,
  PlannerEnrollmentDataType,
  ShoppingCartEnrollmentDataType,
  TutorMatchEnrollmentDataType,
};
